<template>
  <div class="columns is-padding-top-xsmall line-notification">
    <div class="column is-narrow is-padding-left-small is-paddingless-right is-paddingless-top is-padding-bottom-small">
      <span class="avatar">
        <span class="has-bg-notification has-text-white">
          <i class="fal fa-bell"></i>
        </span>
      </span>
    </div>
    <div class="column is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
      <a @click.prevent.stop="remove"><i class="fal fa-trash has-text-grey"></i></a>
      <p class="has-text-grey is-size-7 is-margin-bottom-xsmall">{{ event.created_on | timeDelta }}</p>
      <p class="is-size-4"><strong>{{event.title}}</strong></p>
      <p class="is-size-6 has-text-grey">{{event.description}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EventRow',
    props: {
      event: {
        type: Object,
        required: true
      }
    },
    components: {},
    data () {
      return {}
    },
    computed: {},
    methods: {
      remove () {
        this.$emit('remove', this.event.pk)
      }
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/event/EventRow.vue